import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILeadAssetProfile, type IPrivateAsset, leadAssetProfilesManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { PRIVATE_ASSET_MODULE } from '../private-asset-module';

export const UPDATE_LINK = 'updateLink';
export const OVERRIDE_EVALUATE = 'overrideEvaluate';

export const actions: ActionTree<ILeadAssetProfile, unknown> = {
    async [UPDATE_LINK](
        context,
        { profileId, directoryAssetId, properties }: { profileId: number; directoryAssetId?: number; properties?: string }
    ): Promise<void> {
        const updated = await leadAssetProfilesManager.updateLink(profileId, directoryAssetId, { properties });
        return context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updated] });
    },
    async [OVERRIDE_EVALUATE](
        context,
        { profileId, evaluateId, oldId, properties }: { profileId: number; evaluateId: number; oldId?: number; properties?: string }
    ): Promise<void> {
        const updated = await leadAssetProfilesManager.overrideEvaluate(profileId, evaluateId, oldId, { properties });
        return context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updated] });
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILeadAssetProfile[] }) {
        const leadAssetProfiles: ILeadAssetProfile[] = [];
        const assetEntities: IPrivateAsset[] = [];

        dataObjectList.forEach((leadAssetProfile) => {
            const _leadAssetProfile = Object.assign({}, leadAssetProfile);

            if (isDataObject<IPrivateAsset>(leadAssetProfile.assetEntity)) {
                const assetEntity = Object.assign({}, leadAssetProfile.assetEntity);
                _leadAssetProfile.assetEntity = assetEntity.dobjId;
                assetEntities.push(assetEntity);
            }

            leadAssetProfiles.push(_leadAssetProfile);
        });

        if (leadAssetProfiles.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: leadAssetProfiles });
        }
        if (assetEntities.length > 0) {
            void context.dispatch(`${PRIVATE_ASSET_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: assetEntities }, { root: true });
        }
    }
};
